import TimeLogs from "../time-tracking/time-logs";

export default function TimeLogsPage() {
  return (
    <div className="container py-6">
      <TimeLogs />
    </div>
  );
} 